import React from 'react';
import Inventory from 'inventoryReconciliations/type/inventory';
import { Provider } from 'mobx-react';
import InventoryReconciliationStore from 'inventoryReconciliations/store/InventoryReconciliationStore';
import InventoryReconcilation from 'inventoryReconciliations/components/InventoryReconcilation';
import { Pagy } from 'shared/Pagynation';

interface InventoryReconcilationContainerProps {
  inventories: Inventory[];
  pagy: Pagy;
  canGenerateReport?: boolean;
  cooldownActive?: boolean;
  nextAvailableAt?: string | null;
  generateReportPath: string;
}

const InventoryReconcilationContainer = ({
  inventories,
  pagy,
  canGenerateReport = false,
  cooldownActive = false,
  nextAvailableAt = null,
  generateReportPath,
}: InventoryReconcilationContainerProps) => {
  return (
    <Provider
      inventoryReconciliationStore={new InventoryReconciliationStore(inventories, pagy)}
    >
      <InventoryReconcilation
        canGenerateReport={canGenerateReport}
        cooldownActive={cooldownActive}
        nextAvailableAt={nextAvailableAt}
        generateReportPath={generateReportPath}
      />
    </Provider>
  );
};

export default InventoryReconcilationContainer;
